import { Box, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Store";
import SummaryStatCards from "../../components/Stats/SummaryStatCards";
import PageTitle from "../../components/Page Component/PageTitle";
import DownloadSkillsReview from "./DownloadSkillsReview";
import SkillHistory from "./SkillHistory";
import EmployeesWithNoSkillResponses from "./EmployeesWithNoSkillResponses";

const SkillsReports = () => {
  const [value, setValue] = React.useState(0);

  const selectedRoleFromStore = useSelector((state: RootState) => state.auth.selectedRole);
  const selectedRole = selectedRoleFromStore || localStorage.getItem("selectedRole") || "";
  const isHR = selectedRole.toLowerCase() === "hr";

  return (
    <Box sx={{ width: "100%", mt: 10, mb: 10 }}>
      <Box sx={{ mb: 3, px: 2 }}>
        <PageTitle>Reports</PageTitle>
        <Typography variant="body1" color="textSecondary" sx={{ mt: 2 }}>
          Export skill reports and track pending assessments
        </Typography>
      </Box>
      <SummaryStatCards
        items={[
          {
            label: "Reviews Summary",
            value: "Export skills review report",
            color: "success.main",
            onClick: () => setValue(0),
            active: value === 0,
          },
          {
            label: "Review History",
            value: "View historical skill changes",
            color: "info.main",
            onClick: () => setValue(1),
            active: value === 1,
          },
          ...(isHR
            ? [
                {
                  label: "Pending Assessments",
                  value: "Employees pending assessment",
                  color: "warning.main",
                  onClick: () => setValue(2),
                  active: value === 2,
                },
              ]
            : []),
        ]}
      />
      <Box sx={{ width: "100%" }}>
        {value === 0 && <DownloadSkillsReview />}
        {value === 1 && <SkillHistory />}
        {value === 2 && isHR && <EmployeesWithNoSkillResponses />}
      </Box>
    </Box>
  );
};

export default SkillsReports;
